import React from "react";
import { graphql, Link } from "gatsby";
import styled from "@emotion/styled";
import Layout from "../components/Layout";
import Nav from "../components/Nav";
import Metiers from "../components/Metiers";
import Contact from "../components/ContactV2";
import Footer from "../components/Footer";
import Helmet from "react-helmet";
import { variablesSubstitution } from "../components/Variables";

const VideoTemplate = ({ data }) => {
  const post = data.markdownRemark;

  return (
    <Layout>
      <Helmet>
        <title>{variablesSubstitution(post.frontmatter.metaTitle)}</title>
        <meta
          name="description"
          content={variablesSubstitution(post.frontmatter.metaDescription)}
        />
      </Helmet>
      <Nav />
      <Wrapper>
        <Main>
          <BreadCrumb>
            <StyledLink to="/">Accueil</StyledLink> >{" "}
            <StyledLink to="/videos/">ÉMISSIONS TV / VIDÉOS</StyledLink>
          </BreadCrumb>
          <H1>{variablesSubstitution(post.frontmatter.title)}</H1>
          <Media>{variablesSubstitution(post.frontmatter.media)}</Media>

          <div
            dangerouslySetInnerHTML={{
              __html: variablesSubstitution(post.html),
            }}
          />
        </Main>
        <Aside>
          <p />
          <Contact />
          <Metiers />
        </Aside>
      </Wrapper>

      <Footer pathEn={post.frontmatter.pathEn} />
    </Layout>
  );
};

export const query = graphql`
  query ($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        pathEn
        media
        metaTitle
        metaDescription
        imageAlt
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  width: 1250px;
  margin: 0 auto 3em;
  max-width: 100%;
  @media (max-width: 678px) {
    display: block;
  }
`;

const Main = styled.main`
  flex: 72%;
  padding-top: 25px;
  @media only screen and (max-width: 768px) {
    padding: 20px 12px 0;
  }
`;

const BreadCrumb = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: 0.78em;
  line-height: 1.5em;
  margin: 0;
  @media only screen and (max-width: 768px) {
    font-size: 0.7em;
  }
`;

const StyledLink = styled(Link)`
  color: #333;
  text-decoration: none;
  letter-spacing: 0.01em;
  margin: 0 0.5em;
  transition: all 0.1s ease-in-out;
  :hover {
    transition: all 0.1s ease-in-out;
    color: #7a9282;
    text-decoration: underline;
  }
`;

const Aside = styled.aside`
  flex: 28%;
  padding-left: 20px;
  padding-top: 15px;
  @media only screen and (max-width: 768px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

const H1 = styled.h1`
  text-align: center;
  border: none;
  margin: 0;
  font-size: 1.8em;
  padding: 0 8px;
  @media only screen and (max-width: 768px) {
    font-size: 1.38em;
  }
`;

const Media = styled.div`
  text-align: center;
  color: #7a9282;
  font-weight: 600;
  font-size: 0.87em;
  margin-bottom: 25px;
  @media only screen and (max-width: 768px) {
    font-size: 0.82em;
    margin-bottom: 15px;
  }
`;

export default VideoTemplate;
